<div fxLayout="row" style="margin-top: 10px">
  <div fxFlex="100" style="padding: 5px">
    <div style="display: flex">
      <div class="button-row" style="display: flex; align-items: center">
        <button
          mat-flat-button
          color="primary"
          routerLink="/catalogo-item-new/"
        >
          Agregar variedad
        </button>
        <button mat-flat-button color="primary">Exportar plantilla</button>
      </div>
    </div>

    <!-- ============================================== -->
    <div
      fxLayout="row wrap"
      fxLayoutAlign="space-between center"
      class="top-panel-control content-body"
    >
      <!-- variety filter -->
      <mat-form-field fxFlex="12" appearance="outline">
        <mat-label>Variedad</mat-label>
        <input
          type="text"
          placeholder="Seleccione uno..."
          aria-label="Number"
          matInput
          [formControl]="variety_control"
          [matAutocomplete]="auto1"
        />
        <button
          mat-button
          matSuffix
          aria-label="Arrow"
          *ngIf="!variety_control.value"
          mat-icon-button
          class="mat-select-arrow-wrapper"
        >
          <div class="mat-select-arrow"></div>
        </button>
        <button
          mat-button
          *ngIf="variety_control.value"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="variety_control.setValue(''); fnSearchVariety()"
        >
          <mat-icon>close</mat-icon>
        </button>
        <mat-autocomplete
          autoActiveFirstOption
          #auto1="matAutocomplete"
          panelWidth="24em"
          (optionSelected)="fnSearchVariety()"
        >
          <mat-option
            *ngFor="let option of filteredOptionsVariety | async"
            [value]="option"
          >
            {{ option }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <!-- Users -->
      <mat-form-field
        fxFlex="17"
        fxFlex.sm="50"
        fxFlex.xs="100"
        appearance="outline"
        *ngIf="filteredOptionsUser | async as userList"
      >
        <mat-label>Tipo de organización</mat-label>
        <input
          type="text"
          placeholder="Seleccione uno..."
          matInput
          [formControl]="user_control"
          [matAutocomplete]="auto5"
        />
        <button
          mat-button
          matSuffix
          *ngIf="!user_control.value"
          mat-icon-button
          class="mat-select-arrow-wrapper"
        >
          <div class="mat-select-arrow"></div>
        </button>
        <button
          mat-button
          *ngIf="user_control.value"
          matSuffix
          mat-icon-button
          (click)="user_control.setValue(''); fnSearchVariety()"
        >
          <mat-icon>close</mat-icon>
        </button>
        <mat-autocomplete
          autoActiveFirstOption
          #auto5="matAutocomplete"
          panelWidth="30em"
          [displayWith]="displayFnUser"
          (optionSelected)="fnSearchVariety()"
        >
          <mat-option *ngFor="let option of userList.data" [value]="option">
            {{ option.username }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <!-- country filter -->
      <mat-form-field
        fxFlex="12"
        appearance="outline"
        *ngIf="filteredOptionsCountry | async as countryData"
      >
        <mat-label>País</mat-label>
        <mat-select
          [(ngModel)]="country_value"
          name="country_name"
          (selectionChange)="fnSearchVariety()"
        >
          <mat-option value="Todos">Todos</mat-option>
          <mat-option *ngFor="let option of countryData.data" [value]="option">
            {{ option }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <!-- region filter -->
      <mat-form-field
        fxFlex="12"
        appearance="outline"
        *ngIf="filteredOptionsRegion | async as regionData"
      >
        <mat-label>Región</mat-label>
        <input
          type="text"
          placeholder="Seleccione uno..."
          aria-label="Number"
          matInput
          [formControl]="region_control"
          [matAutocomplete]="auto3"
        />
        <button
          mat-button
          matSuffix
          aria-label="Arrow"
          *ngIf="!region_control.value"
          mat-icon-button
          class="mat-select-arrow-wrapper"
        >
          <div class="mat-select-arrow"></div>
        </button>
        <button
          mat-button
          *ngIf="region_control.value"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="region_control.setValue(''); fnSearchVariety()"
        >
          <mat-icon>close</mat-icon>
        </button>
        <mat-autocomplete
          autoActiveFirstOption
          #auto3="matAutocomplete"
          panelWidth="12em"
          (optionSelected)="fnSearchVariety()"
        >
          <mat-option *ngFor="let option of regionData.data" [value]="option">
            {{ option }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <!-- variety group filter -->
      <mat-form-field
        fxFlex="12"
        appearance="outline"
        *ngIf="filteredOptionsVarietyGroup | async as varietyGroupList"
      >
        <mat-label>Grupo varietal</mat-label>

        <mat-select
          [(ngModel)]="varietal_group_value"
          name="varietal_group_name"
          (selectionChange)="fnSearchVariety()"
        >
          <mat-option value="Todos">Todos</mat-option>

          <mat-option
            *ngFor="let option of varietyGroupList.data"
            [value]="option"
          >
            {{ option }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <!-- is original -->
      <mat-form-field fxFlex="12" appearance="outline">
        <mat-label>Es original</mat-label>
        <mat-select
          [(ngModel)]="is_original_value"
          name="is_original_name"
          (selectionChange)="fnSearchVariety()"
        >
          <mat-option value="Todos">Todos</mat-option>
          <mat-option value="Si">Si</mat-option>
          <mat-option value="No">No</mat-option>
        </mat-select>
      </mat-form-field>
      <!-- creation date filter -->
      <mat-form-field fxFlex="12" appearance="outline">
        <mat-label>Fecha de creación</mat-label>
        <input
          matInput
          type="text"
          [matDatepicker]="pickerInit"
          name="observation_date_name"
          (dateChange)="fnSearchVariety()"
          [formControl]="observation_date_control"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="pickerInit"
        ></mat-datepicker-toggle>
        <mat-datepicker #pickerInit color="primary"></mat-datepicker>
      </mat-form-field>

      <!-- clear filter -->
      <button mat-stroked-button (click)="fnClearFilters()">
        <mat-icon>restart_alt</mat-icon> Reiniciar
      </button>
    </div>
    <!-- ============================================== -->

    <div fxLayout="column" fxLayoutAlign="space-between stretch">
      <div
        style="
          margin-bottom: 0.5em;
          border: solid 1px #ddd;
          padding: 0.5em;
          background-color: #fff;
          color: #8b2f00;
          font-weight: 500;
        "
      >
        <div
          fxFlex="12"
          style="display: flex; justify-content: center; align-items: center"
        >
          <span>Multimedia</span>
        </div>
        <div
          fxFlex="21"
          style="display: flex; justify-content: center; align-items: center"
        >
          <span>Nombre de variedad</span>
        </div>
        <div
          fxFlex="21"
          style="display: flex; justify-content: center; align-items: center"
        >
          <span>Usuario/Entidad</span>
        </div>
        <div
          fxFlex="15"
          style="display: flex; justify-content: center; align-items: center"
        >
          <span>Nombre de especie</span>
        </div>
        <div
          fxFlex="16"
          style="display: flex; justify-content: center; align-items: center"
        >
          <span>Sinonimo</span>
        </div>
        <!-- <div
          fxFlex="12"
          style="display: flex; justify-content: center; align-items: center"
        >
          <span>Es original</span>
        </div> -->
        <div
          fxFlex="15"
          style="display: flex; justify-content: center; align-items: center"
        >
          <span>Acción</span>
        </div>
      </div>

      <div *ngFor="let cardContent of cardContentList">
        <app-template-row-edit-var
          [cardContent]="cardContent"
          [route]="'catalogo-item'"
        ></app-template-row-edit-var>
      </div>
    </div>
    <mat-paginator
      [pageIndex]="page_control"
      [pageSize]="page_size_control"
      [length]="_length"
      [showFirstLastButtons]="_showFirstLastButtons"
      [pageSizeOptions]="_pageSizeOptions"
      (page)="handlePageEvent($event)"
      aria-label="Select page"
      class="content-body"
    >
    </mat-paginator>
  </div>
</div>
